import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Platform } from '../../../../platform-call';

import { TranslationKeyMap } from './transcript-title.pipe.i18n';

@Pipe({
    name: 'cmpsTranscriptTitle',
})
export class TranscriptTitlePipe implements PipeTransform {
    private readonly _unknownLabel: string;
    private readonly _labels: { [key: string]: string };

    constructor(private readonly _translateService: TranslateService) {
        this._unknownLabel = this._translateService.instant(
            TranslationKeyMap.__TRANSCRIPT,
        ) as string;
        this._labels = {
            [Platform.LOCAL]: this._translateService.instant(
                TranslationKeyMap.__SXS_TRANSCRIPT,
            ) as string,
            [Platform.MICROSOFT]: this._translateService.instant(
                TranslationKeyMap.__CALL_TRANSCRIPT,
            ) as string,
        };
    }

    transform(transcript?: {
        platform?: Platform;
        transcriptId?: number;
        title?: string;
    }): string | null {
        if (transcript == null) {
            return null;
        }

        const title = transcript?.title?.trim();
        if (title?.length > 0) {
            return title;
        }

        const label: string =
            transcript.platform in this._labels
                ? this._labels[transcript.platform]
                : this._unknownLabel;
        return `${label} ${transcript.transcriptId?.toString() ?? ''}`.trim();
    }
}
